import { Directive, HostListener, ElementRef } from '@angular/core';
import { NglDropdown } from './dropdown';
var NglDropdownTrigger = (function () {
    function NglDropdownTrigger(element, dropdown) {
        this.element = element;
        this.dropdown = dropdown;
        this.parentFocusEventSubscription = this.dropdown.triggerFocusEventEmitter.subscribe(this.focus.bind(this));
    }
    NglDropdownTrigger.prototype.ngOnDestroy = function () {
        this.parentFocusEventSubscription.unsubscribe();
    };
    NglDropdownTrigger.prototype.toggleOpen = function () {
        this.dropdown.toggle();
    };
    NglDropdownTrigger.prototype.onKeyDownOpen = function ($event) {
        $event.preventDefault();
        this.dropdown.toggle(true);
    };
    NglDropdownTrigger.prototype.focus = function () {
        this.element.nativeElement.focus();
    };
    NglDropdownTrigger.decorators = [
        { type: Directive, args: [{
                    selector: '[nglDropdownTrigger]',
                    host: {
                        'aria-haspopup': 'true',
                    },
                },] },
    ];
    /** @nocollapse */
    NglDropdownTrigger.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: NglDropdown, },
    ]; };
    NglDropdownTrigger.propDecorators = {
        'toggleOpen': [{ type: HostListener, args: ['click',] },],
        'onKeyDownOpen': [{ type: HostListener, args: ['keydown.arrowdown', ['$event'],] },],
    };
    return NglDropdownTrigger;
}());
export { NglDropdownTrigger };
//# sourceMappingURL=dropdown-trigger.js.map